<template>
    <section ref="cardsSection" class="cards-section container-fluid set-height100 position-relative">
        <div class="container set-absolute">
            <div class="row justify-content-center">
                <div class="col-md-9 col-lg-6 main-container-card">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">
                                <p class="text-center">{{ $t('formation.cards.offline.title') }}</p>
                                <p class="text-center">{{ $t('formation.cards.offline.subTitle') }}</p>
                            </h5>
                            <p class="card-text">
                              {{ $t('formation.cards.offline.text_1') }}<br />
                              {{ $t('formation.cards.offline.text_2') }}
                            </p>
                            <div class="card-table">
                                <table class="table table-striped">
                                    <tbody>
                                        <tr>
                                            <td>{{ $t('formation.cards.specs.mandatoryCard') }}</td>
                                            <td><i class="fas fa-times"></i></td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('formation.cards.specs.withoutFees') }}</td>
                                            <td><i class="fas fa-check"></i></td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('formation.cards.specs.onSitePayment') }}</td>
                                            <td><i class="fas fa-check"></i></td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('formation.cards.specs.access') }}</td>
                                            <td><i class="fas fa-times"></i></td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('formation.cards.specs.groups') }}</td>
                                            <td><i class="fas fa-check"></i></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <p class="text-center"><router-link :to="{ name:'formation_offline' }" class="btn">{{ $t('formation.cards.offline.send') }}</router-link></p>
                        </div>
                    </div>
                </div>
                <div class="col-md-9 col-lg-6 main-container-card">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">
                                <p class="text-center">{{ $t('formation.cards.online.title') }}</p>
                                <p class="text-center">{{ $t('formation.cards.online.subTitle') }}</p>
                            </h5>
                            <p class="card-text">
                              {{ $t('formation.cards.online.text') }}
                            </p>
                            <div class="card-table">
                                <table class="table table-striped">
                                    <tbody>
                                      <tr>
                                        <td>{{ $t('formation.cards.specs.mandatoryCard') }}</td>
                                        <td><i class="fas fa-check"></i></td>
                                      </tr>
                                      <tr>
                                        <td>{{ $t('formation.cards.specs.withoutFees') }}</td>
                                        <td><i class="fas fa-check"></i></td>
                                      </tr>
                                      <tr>
                                        <td>{{ $t('formation.cards.specs.onSitePayment') }}</td>
                                        <td><i class="fas fa-check"></i></td>
                                      </tr>
                                      <tr>
                                        <td>{{ $t('formation.cards.specs.access') }}</td>
                                        <td><i class="fas fa-check"></i></td>
                                      </tr>
                                      <tr>
                                        <td>{{ $t('formation.cards.specs.groups') }}</td>
                                        <td><i class="fas fa-check"></i></td>
                                      </tr>
                                    </tbody>
                                </table>
                            </div>
                            <p class="text-center"><router-link :to="{ name:'home_search' }" class="btn text-center">{{ $t('formation.cards.online.send') }}</router-link></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
  created () {
    this.$root.$on('eventing', data => {
      let element = this.$refs['cardsSection']
      let top = element.offsetTop

      window.scrollTo(0, top)
    })
  }
}
</script>
<style lang="scss" scoped>
.fas{
    font-size: 1.1rem;
}

.cards-section{
    padding-top: 4rem;
    padding-bottom: 2rem;
}
.cards-section .main-container-card{
    margin-bottom: 2rem;
}
.card{
    .fa-check{
        color:green;
    }
    .fa-times{
        color: red;
    }
    h5{
        color: #1A2050;
    }
    .card-title p:first-child{
        font-size: 2rem;
    }
    .card-text{
        padding-top: 3rem;
        color: #1A2050;
    }
    .table{
        margin-top: 2rem;
    }
    .btn{
      margin-top: 3rem;
      margin-bottom: 2rem;
      background-color: #E65011;
      color: white;
    }
    .btn:hover{
        color: #212529;
    }
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding-top: 2rem;
    box-shadow: 5px 8px 9px -4px rgba(0, 0, 0, 0.56);
}

@media (min-width: 576px) {
    .container{
        max-width: 540px;
    }
}
@media (min-width: 768px) {
    .container{
        max-width: 720px;
    }
}
@media (min-width: 992px) {
    .set-height100 {
        height: 100vh;
    }
    .cards-section .set-absolute{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .container{
        max-width: 960px;
    }
    .cards-section .main-container-card{
    margin-bottom: 0;
}
}
@media (min-width: 1200) {
    .container{
        max-width: 1140;
    }
}
@media (min-width: 1400px) {
    .container{
        max-width: 1320px;
    }
}
</style>
